import { EVENT_TYPE } from '@/common/resources/const'
import { convertEventOnDisplay } from '@/common/converter/convert-event-on-display'
import { convertEventOnContent } from '@/common/converter/convert-event-on-content'
import { convertEventOnViewMore } from '@/common/converter/convert-event-on-view-more'
import { convertEventOnClick } from '@/common/converter/convert-event-on-click'
import { convertEventOnNavigation } from '@/common/converter/convert-event-on-navigation'
import { convertEventOnDetail } from '@/common/converter/convert-event-on-detail'
import { convertEventOnInstantPlay } from '@/common/converter/convert-event-on-instant-play'
import { convertEventOnZzim } from '@/common/converter/convert-event-on-zzim'
import { convertEventOffZzim } from '@/common/converter/convert-event-off-zzim'

/**
 * get event(type), element-list mapping to old event list structure
 * @param event
 * @param elements
 * @returns {{cta: string, add_timestamp: string, method: string, add_common_params: string, bodylist: *, add_credential: string, type: string, url: *}|{}|{type: string, url: string, method: string, bodylist: [], add_common_params: string, add_timestamp: string, add_credential: string}|undefined}
 */
export const mapEventList = (event = '', elements = []) => {
  switch (event) {
    case EVENT_TYPE.ON_DISPLAY:
      return convertEventOnDisplay(elements)

    case EVENT_TYPE.ON_CONTENT:
      return convertEventOnContent(elements)

    case EVENT_TYPE.ON_VIEW_MORE:
      return convertEventOnViewMore(elements)

    case EVENT_TYPE.ON_CLICK:
      return convertEventOnClick(elements)

    case EVENT_TYPE.ON_NAVIGATION:
      return convertEventOnNavigation(elements)

    case EVENT_TYPE.ON_DETAIL:
      return convertEventOnDetail(elements)

    case EVENT_TYPE.ON_INSTANT_PLAY:
      return convertEventOnInstantPlay(elements)

    case EVENT_TYPE.ON_ZZIM:
      return convertEventOnZzim(elements)

    case EVENT_TYPE.OFF_ZZIM:
      return convertEventOffZzim(elements)

    default:
      return null
  }
}
